<template>
  <div>
    <qx-card title="档案信息" class="detail" v-loading="loading">
      <!-- 订单详情数据 -->
      <qx-detail-box v-for="(data, index) in detailData" :data="data" :key="index" />
      <!-- 订单详情数据 end -->
    </qx-card>
    <!-- <ApproveBox
      v-if="(type ||$route.query.type) === 'approve'"
      :busiId="id ? String(id) : $route.query.id"
      busiCode="100000"
      :inFast="Boolean(id)"
    />-->
  </div>
</template>

<script>
import {
  queryByAfId, // 获取详情
} from 'api/distribution';
// import ApproveBox from 'components/approveBox';
export default {
  // components: {
  // ApproveBox,
  // },
  props: {
    id: {
      type: Number,
    },
    type: {
      type: String,
    },
  },
  data () {
    return {
      loading: false,
      detailData: {
        base: {
          label: '客户信息',
          tableData: {
            title: [
              { prop: 'customerName', label: '客户名称' },
              { prop: 'consignee', label: '收货方' },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        address: {
          label: '地址信息',
          tableData: {
            title: [
              { prop: 'addressTypeName', label: '地址类型' },
              { prop: 'addressName', label: '地址名称' },
              { prop: 'addressDtl', label: '详细地址' },
              { prop: 'addressNavigation', label: '导航地址' },
              { prop: 'estimatedStayTime', label: '预计停留时间' },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        contacts: {
          label: '联系人信息',
          tableData: {
            title: [
              { prop: 'linkMan1', label: '第一联系人' },
              { prop: 'linkManPhone1', label: '联系人电话' },
              { prop: 'linkMan2', label: '第二联系人' },
              { prop: 'linkManPhone2', label: '联系人电话' },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        instrctions: {
          label: '操作说明',
          tableData: {
            title: [
              { prop: 'opRemarks', label: '操作说明' },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
      },
    };
  },
  computed: {
    colSpan () {
      const total = 24;
      const minSpan = 4;
      return parseInt(total / this.orderInfo.length, 10) < minSpan ? minSpan : parseInt(total / this.orderInfo.length, 10);
    },
  },
  watch: {
    '$route.query.id': function () {
      this.getData();
    },
  },
  methods: {
    async getData () {
      if (this.$route.path !== '/manage/distribution/addressArchives/detail' && !this.id) {
        return;
      }
      this.loading = true;
      const detailRes = await queryByAfId({
        afId: this.id || this.$route.query.id,
      });
      this.loading = false;
      if (!detailRes.failed) {
        for (let item in this.detailData) {
          if (this.detailData[item]) {
            this.detailData[item].tableData.data = detailRes;
          }
        }
      }
    },
  },
  mounted () {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
@import 'styles/config.scss';
.orderStatusBox {
  overflow: auto;
}
.orderInfoBox {
  margin: 16px 12px 0;
  min-height: 124px;
  border: 1px solid $border-color;
  padding: 24px 16px;
  box-sizing: border-box;
  .title {
    font-size: 16px;
    height: 16px;
    line-height: 16px;
    padding-bottom: 16px;
  }
  .desc,
  .time {
    color: #666;
    line-height: 16px;
  }
  .desc {
    padding-bottom: 12px;
  }
}
.box {
  border-top: 1px solid $border-color;
  border-left: 1px solid $border-color;
  border-right: 1px solid $border-color;
}
.itemLabel {
  background: $grey;
}
.itemLabel,
.itemText {
  height: 48px;
  line-height: 48px;
  padding: 0 24px;
  box-sizing: border-box;
  border-bottom: 1px solid $border-color;
}
</style>
